import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
  getEntity,
} from '@infotech/lib-api-middleware'
import { ESUZ_CORE_URL } from './constants'

export const ESUZ_ISSUES_SCHEMA_NAME = `esuzIssues`
export const URL = `${ESUZ_CORE_URL}/issues/`

const esuzIssuesSchema = new schema.Entity(ESUZ_ISSUES_SCHEMA_NAME)
export const esuzIssuesSelector = createSelectorForEntityKey(ESUZ_ISSUES_SCHEMA_NAME)
export const esuzIssuesEntitiesSelector = createEntitiesSelector(ESUZ_ISSUES_SCHEMA_NAME)
export const esuzIssuesApiActions = actionCrudCreatorsFor(ESUZ_ISSUES_SCHEMA_NAME, URL, esuzIssuesSchema)
export const singleEsuzIssueSelector = (state, id) => getEntity(state, ESUZ_ISSUES_SCHEMA_NAME, id)
